import React, {Component} from 'react';
import {withRouter} from 'react-router'
import {
    Badge,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown,
    Progress,
} from 'reactstrap';
import * as sessionService from '../../services/session';
import * as apiService from '../../services/session/api';
import {connect} from 'react-redux';

class HeaderDropdownAction extends Component {

    constructor(props) {

        super(props);

        this.toggle = this.toggle.bind(this);
        this.logout = this.logout.bind(this);

        this.state = {
            dropdownOpen: false,
        };



    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    logout() {


        sessionService.revoke().then((res) => {

            this.props.history.push('/login');

        });

    }

    logoutCostumer() {

        apiService.disabledCostumer().then((data) => {

            window.location.reload(); 
            
        }); 

    }

    render() {

        const {history} = this.props;

        return (
            <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <i className="fp fp-menu" />
                </DropdownToggle>
                <DropdownMenu right>
                    {(sessionService.testRole('ROLE_ADMIN') || sessionService.testRole('ROLE_TCP') || sessionService.testRole('ROLE_ADV')) && <DropdownItem header tag="div" className="text-center"><strong>Menu</strong></DropdownItem>}
                    {(sessionService.testRole('ROLE_ADMIN') || sessionService.testRole('ROLE_TCP')) &&  <DropdownItem onClick={() => history.push('/seller-dashboard')}><i className="icon-speedometer"></i> Tableau de bord</DropdownItem>}
                    {sessionService.testRole('ROLE_ADMIN') && <DropdownItem onClick={() => history.push('/members') || sessionService.testRole('ROLE_ADV')}><i className="fa fa-users"></i> Membres</DropdownItem>}
                    {sessionService.testRole('ROLE_ADMIN') && <DropdownItem onClick={() => history.push('/families') || sessionService.testRole('ROLE_ADV')}><i className="fa fa-leaf"></i> Familles</DropdownItem>}
                    {sessionService.testRole('ROLE_ADMIN') && <DropdownItem onClick={() => history.push('/deposits') || sessionService.testRole('ROLE_ADV')}><i className="fa fa-truck"></i> Dépôts</DropdownItem>}
                    {sessionService.testRole('ROLE_ADMIN') && <DropdownItem onClick={() => history.push('/depositCategories') || sessionService.testRole('ROLE_ADV')}><i className="fa fa-truck"></i> Catégories de dépots</DropdownItem>}

                    {(sessionService.testRole('ROLE_ADMIN') || sessionService.testRole('ROLE_TCP') || sessionService.testRole('ROLE_ADV')) && <DropdownItem onClick={() => history.push('/costumers')}><i className="fp-client" /> Clients</DropdownItem>}
                    <DropdownItem header tag="div" className="text-center"><strong>Mon compte</strong></DropdownItem>
                    <DropdownItem onClick={() => history.push('/account/profil')}><i className="fp-menu" />
                        Profil</DropdownItem>
                    <DropdownItem onClick={()=>history.push('/account/password')}><i className="fa fa-key" /> Changer de mot de passe</DropdownItem>
                    {!sessionService.testRole('ROLE_USER') && this.props.user.organisation && <DropdownItem onClick={() => this.logoutCostumer()}><i className="fa fa-delete"></i> Déconnecter le client</DropdownItem>}
                    <DropdownItem onClick={() => this.logout()}><i className="fa fa-lock"></i> Se deconnecter</DropdownItem>
                    {/*<DropdownItem divider/>*/}

                </DropdownMenu>
            </Dropdown>
        );
    }
}


const mapStateToProps = state => ({
    user: state.user
});

const mapDispatchToProps = dispatch => ({});

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(HeaderDropdownAction));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdownAction.js